/**
 * Athlete-comparison metric formatting.
 * Sign, digits, and Latin units stay in one LTR string so RTL pages
 * do not render "+741 min" as "min 741+".
 */
export function formatAthleteMetricValue(
  value: number | null | undefined,
  unit: string,
  locale: string,
  options?: { signed?: boolean },
): string {
  if (value == null) return '—';
  const formatted = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
    ...(options?.signed ? { signDisplay: 'exceptZero' as const } : {}),
  }).format(Math.round(value));
  return unit ? `${formatted} ${unit}` : formatted;
}
